import React, { Component } from 'react';

import { importStaticOrFromLocal } from 'utils';

import styles from './bestCompanyToWorkCard.module.css';

class BestCompanyToWorkCard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      disableShow: true,
      renderCompanyList: props.topCompaniesList.slice(0, 12),
      storeIndex: 12,
    };
  }

  onClickMore = () => {
    const { disableShow, storeIndex } = this.state;
    const { topCompaniesList } = this.props;

    if (!disableShow) {
      this.setState({
        renderCompanyList: topCompaniesList,
      });
    } else {
      this.setState((prevState) => ({
        renderCompanyList: [
          ...prevState.renderCompanyList,
          ...topCompaniesList.slice(storeIndex, storeIndex + 12),
        ],
        storeIndex: prevState.storeIndex + 12,
        disableShow: storeIndex + 12 !== topCompaniesList.length,
      }));
    }
  };

  location = (CP) => {
    if (CP.companyCity && CP.companyStateCode) {
      return `${CP.companyCity}, ${CP.companyStateCode}`;
    }
    if (CP.companyCity) {
      return `${CP.companyCity}`;
    }
    return `${CP.companyStateCode}`;
  };

  imageErrorFunc = (index) => {
    this.setState({
      [`imageError${index}`]: true,
    });
  };

  render() {
    const { disableShow, renderCompanyList } = this.state;

    return (
      <div className={styles['best-companies-container']}>
        <div className="row m-0">
          {renderCompanyList &&
            renderCompanyList.map((company, index) => (
              <div className={`col-lg-3 col-sm-6 col-12 ${styles['side-padding']}`} key={index}>
                <a href={company.companyLink}>
                  <div className={styles['company-container']}>
                    <div className={`${styles['company-image']} ${styles['styles.noSelect']}`}>
                      <img
                        src={
                          this.state[`imageError${index}`] ||
                          typeof company.companyLogo === 'undefined'
                            ? importStaticOrFromLocal('/ui-router/images/big-company-icon.svg')
                            : company.companyLogo
                        }
                        alt={company.companyNameCPS}
                        onError={() => this.imageErrorFunc(index)}
                        width="48"
                        height="48"
                      />
                    </div>
                    <div className={styles['company-details']}>
                      <div className={styles['company-name']}>{company.companyNameCPS}</div>
                      <div className={styles['company-location']}>{this.location(company)}</div>
                    </div>
                  </div>
                </a>
              </div>
            ))}
          {disableShow ? (
            <span className={styles['show-more-text']} onClick={this.onClickMore}>
              Show More
            </span>
          ) : (
            <span className="show-more-text" />
          )}
        </div>
      </div>
    );
  }
}

export default BestCompanyToWorkCard;
